import useUserCentrics from '@hooks/useUserCentrics'
import { useEffect, useRef } from 'react'
import { useTheme } from 'styled-components'

const getSnippets = () => {
  const sunpointApiKey =
    process.env.NEXT_PUBLIC_GTM_API_KEY_SUNPOINT || '9a3bc996'
  const wellmaxxApiKey =
    process.env.NEXT_PUBLIC_GTM_API_KEY_WELLMAXX || '36c7de25'

  return {
    sunpoint: {
      head: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src="https://load.st.sunpoint.de/8uxiebgwkjrre.js?"+i;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','680v11n=aWQ9R1RNLVA1OFdQMlA1&apiKey=${sunpointApiKey}');`,
      body: `<iframe src="https://load.st.sunpoint.de/ns.html?id=GTM-P58WP2P5" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
    },
    wellmaxx: {
      head: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src="https://load.st.wellmaxx-bodyforming.com/7p7zekzhtlrj.js?"+i;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','axw4=aWQ9R1RNLVdRWjdONTc%3D&apiKey=${wellmaxxApiKey}');`,
      body: `<iframe src="https://load.st.wellmaxx-bodyforming.com/ns.html?id=GTM-WQZ7N57" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
    },
  } as const
}

const initializeTagManager = (theme: 'sunpoint' | 'wellmaxx') => {
  const snippets = getSnippets()
  const headElement = document.createElement('script')
  headElement.innerHTML = snippets[theme].head

  const bodyElement = document.createElement('noscript')
  bodyElement.innerHTML = snippets[theme].body

  document.head.insertBefore(headElement, document.head.childNodes[0])
  document.body.insertBefore(bodyElement, document.body.childNodes[0])
}

const useTagmanager = () => {
  const tagManagerLoaded = useRef<boolean>(false)
  const { consentGoogleMaps } = useUserCentrics()
  const theme: any = useTheme()

  useEffect(() => {
    if (
      typeof document === 'undefined' ||
      tagManagerLoaded.current ||
      !consentGoogleMaps
    ) {
      return
    }

    initializeTagManager(theme.key)

    tagManagerLoaded.current = true
  }, [consentGoogleMaps, theme.key])

  return {}
}

export default useTagmanager
